import styles from "./TokenSelect.module.css"
import { RiStarFill, RiStarLine } from "react-icons/ri";
import { CgUnavailable} from "react-icons/cg"


const TokenSelect = (props) => {
    const { icon, qty, symbol, name } = props
    
    function getRandomInt(max) {
        return Math.floor(Math.random() * 18000);
    }
    
    let fakeQty = getRandomInt()

    const noTokenImage = <CgUnavailable  size={20} />
      
  return (
    <div className={styles.modal_content}>
    <div className={styles.modal_tokens_info}>
      <RiStarFill  size={20} className={styles.star_filled} />
      <RiStarLine  size={20} className={styles.star_line} />
              {icon ? <img src={icon} alt="" width="27px" /> : noTokenImage }
              <span className={styles.modal_token_symbol}>{ symbol}</span>
              <span className={styles.modal_token_name}>{ name}</span>
    </div>
          <div className={styles.modal_tokens_amount}>{ fakeQty}</div>

  </div>
  )
}

export default TokenSelect